/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */
import React from "react";

import { usePlayerTranslation } from "../../../../../../shared/context/PlayerTranslationContext";
import {
  DropdownHeader,
  DropdownMenuItem,
  DropdownMenuSection,
  DropdownScrollableArea,
} from "../../../../Base";

import { usePlaybackRateSettings } from "./usePlaybackRateSettings";

export const PlaybackRateSection = () => {
  const { rates, currentPlaybackRate, onRateSelect, formatPlaybackRate } =
    usePlaybackRateSettings();

  const { t } = usePlayerTranslation();

  return (
    <DropdownMenuSection name="playback-rate">
      <DropdownHeader navigateToSection="settings">
        {t("PLAYER_SETTINGS_PLAYBACK_RATE")}
      </DropdownHeader>
      <DropdownScrollableArea>
        {rates.map((playbackRate) => {
          return (
            <DropdownMenuItem
              key={playbackRate}
              onItemSelect={() => onRateSelect(playbackRate)}
              active={playbackRate === currentPlaybackRate}
              resetToDefaultSectionAfterSelect
              showActiveIcon
            >
              {formatPlaybackRate(playbackRate)}
            </DropdownMenuItem>
          );
        })}
      </DropdownScrollableArea>
    </DropdownMenuSection>
  );
};
